import { render } from "./cemNotice.vue?vue&type=template&id=54904f1c"
import script from "./cemNotice.vue?vue&type=script&lang=js"
export * from "./cemNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__